import { AbstractApi } from './abstract-api.js';
import { WishlistBrandListItem } from '../../@types/wishlist.js';

export interface BrandListApi {
  listFollowed(endpoint: string): Promise<WishlistBrandListItem[]>;
}

class BrandListApiClass extends AbstractApi implements BrandListApi {
  async listFollowed(endpoint: string): Promise<WishlistBrandListItem[]> {
    return this.get<WishlistBrandListItem[]>(endpoint, 'BrandList');
  }
}

export const brandListApi: BrandListApi = new BrandListApiClass();
